import React from 'react';

const AdminFormUser = ({ id:key, majUser, users, supprimerUser }) => {
    const user = users[key]
    const handleChange = (event,key) => {
        //recupere le bon champs
        const { name, value } = event.target
        //copier le state initial avant changement
        if(users[key].admin !== "2")
        {
            const user = users[key]
            //setter les champs
            user[name] = value
            //realiser l'update
            majUser(key, user)
        }
    }

    return (
        <div className="card">
                <form className="admin-form " >
                     <input value={user.name} name="name" type="text" placeholder="Nom de l'utilisateur" readOnly/>
                     <div>
                        <input className="radio" type="radio" value="1" name="admin" onChange={e => handleChange(e,key)} checked={user.admin === '1' || user.admin === '2'} /> <label htmlFor="admin">Admin role</label>
                        <input className="radio" type="radio" value="0" name="admin" onChange={e => handleChange(e,key)} checked={user.admin !== '1' && user.admin !== '2'} /> <label htmlFor="admin">User role</label>
                    </div> 
                    <div>
                        <input className="radio" type="radio" value="1" name="confirm" onChange={e => handleChange(e,key)} checked={user.confirm === '1'}/> <label htmlFor="admin">User confirmé</label>
                        <input className="radio" type="radio" value="0" name="confirm" onChange={e => handleChange(e,key)} checked={user.confirm !== '1'} /> <label htmlFor="admin">User en attente</label>
                    </div>   
                </form>
                {users[key].admin !== "2" &&
                <button onClick={() => supprimerUser(key)}> Supprimer </button>
                }
            </div>
    );
};

export default AdminFormUser;